
const customSelect = document.querySelector(".custom-select");
const selectBtn = document.querySelector(".select-button");

const selectedValue = document.querySelector(".selected-value");
const optionsList = document.querySelectorAll(".select-dropdown li");

const searchButton = document.querySelector('.bus-button');
const searchButtonMobile = document.querySelector('.bus-button-mobile');
const searchLink = document.querySelector('.search-link-bus');
const selectDropdown = document.getElementById("select-dropdown");

const busSearchBar = document.querySelector('.bus-search-bar');
let isRounded = false;
// add click event to select button
if (selectBtn)
{
  selectBtn.addEventListener("click", () => {
    if (isRounded) {
      busSearchBar.style.borderBottomLeftRadius = "100px";
    } else {
      busSearchBar.style.borderBottomLeftRadius = "0px";
    }

    isRounded = !isRounded;
    // add/remove active class on the container element
    customSelect.classList.toggle("active");
    // update the aria-expanded attribute based on the current state
    selectBtn.setAttribute(
      "aria-expanded",
      selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true"
    );
  });
}

optionsList.forEach((option) => {
  function handler(e) {
    if (isRounded) {
      busSearchBar.style.borderBottomLeftRadius = "100px";
    } else {
      busSearchBar.style.borderBottomLeftRadius = "0px";
    }
    isRounded = !isRounded;
    // Click Events
    if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
      selectedValue.textContent = this.children[1].textContent;
      customSelect.classList.remove("active");
  
    }
    // Key Events
    if (e.key === "Enter") {
      selectedValue.textContent = this.textContent;
      customSelect.classList.remove("active");
    }
  }

  option.addEventListener("keyup", handler);
  option.addEventListener("click", handler);
});

const searchField = document.querySelector(".search-field-bus");
let searchTimeout;

function performSearch() {
  let busNumber = searchField.value.trim();
  if (busNumber) {
      if (selectedValue.textContent === "Bus No.") {
          searchLink.href = `http://journey.smrt.com.sg/journey/bus_search/bus/${busNumber}/`;
      } else if (selectedValue.textContent === "Bus Stop No.") {
          searchLink.href = `http://journey.smrt.com.sg/journey/bus_search/bus_stop/${busNumber}/`;
      }
  } else {
      searchLink.href = `http://journey.smrt.com.sg/journey/bus_search/bus/#`;
  }
  searchLink.click();
}

if (searchField && searchButton && searchButtonMobile) {
  searchButton.addEventListener("click", function (e) {
      e.preventDefault();
      performSearch();
  });

  searchButtonMobile.addEventListener("click", function (e) {
    e.preventDefault();
    performSearch();
});

  searchField.addEventListener("keyup", function (e) {
      if (e.key === "Enter") {
          performSearch();
      }
  });
}